import { FormControl } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { getFieldError, getFieldPath, useOptionalLabel } from "@shared";
import { FormikValues, getIn } from "formik";

import { FormikDateTimePickerProps } from "./FormikDateTimePicker.types";

export function FormikDateTimePicker<T extends FormikValues>(props: FormikDateTimePickerProps<T>) {
  const {
    fieldName,
    path,
    formControlProps,
    dateOnly,
    formik,
    helperText,
    textFieldProps,
    label,
    required,
    optional,
    ...others
  } = props;

  const fullPath = getFieldPath(path, fieldName);
  const resolvedLabel = useOptionalLabel(label, optional);
  return (
    <FormControl fullWidth {...formControlProps}>
      <DateTimePicker
        name={fullPath}
        format={dateOnly ? "P" : "P p"}
        label={resolvedLabel}
        value={(getIn(formik.values, fullPath) as Date | null | undefined) ?? null}
        slotProps={{
          textField: {
            required,
            variant: "outlined",
            size: "small",
            ...textFieldProps,
            error: !!getFieldError(formik, fullPath),
            helperText: getFieldError(formik, fullPath) ?? helperText ?? " ",
            inputProps: { required: false },
            InputLabelProps: {
              sx: { fontSize: "0.875rem" },
              required,
            },
            InputProps: {
              sx: {
                paddingLeft: 0,
                "& .MuiPickersSectionList-root": {
                  minHeight: "40px",
                  lineHeight: "24px",
                  padding: "8px 14px",
                  fontSize: "0.875rem",
                  alignItems: "center",
                },
              },
            },
          },
        }}
        onChange={(value: Date | null) => void formik.setFieldValue(fullPath, value, false)}
        {...others}
      />
    </FormControl>
  );
}
